import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {DisplayConcept, DisplayField, DisplayTerm, Language} from '@twpub/core/models';
import {
  FeedbackFieldPickerDialogComponent,
  FieldPickerData
} from '@twpub/shared/components/feedback-field-picker-dialog/feedback-field-picker-dialog.component';
import {FeedbackDialogComponent} from '@twpub/shared/components/feedback-dialog/feedback-dialog.component';

export interface FeedbackSectionData {
  sectionType: 'term' | 'classification' | 'concept';
  fields: DisplayField[];
  concept?: DisplayConcept;
  term?: DisplayTerm;
  languages?: Language[];
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackModeService {
  private activeSubject = new BehaviorSubject<boolean>(false);
  active$: Observable<boolean> = this.activeSubject.asObservable();

  private dialog: MatDialog | null = null;

  constructor(private injector: Injector) {
  }

  private getDialog(): MatDialog {
    if (!this.dialog) {
      this.dialog = this.injector.get(MatDialog);
    }
    return this.dialog;
  }

  get isActive(): boolean {
    return this.activeSubject.value;
  }

  toggle(): void {
    this.activeSubject.next(!this.activeSubject.value);
  }

  activate(): void {
    this.activeSubject.next(true);
  }

  deactivate(): void {
    this.activeSubject.next(false);
  }

  openGeneralFeedback(): void {
    this.deactivate();
    this.getDialog().open(FeedbackDialogComponent, {
      width: '600px',
      ariaLabel: $localize`:@@feedback.title:Send Feedback`
    });
  }

  openSectionFeedback(data: FeedbackSectionData): void {
    this.deactivate();
    this.getDialog().open(FeedbackFieldPickerDialogComponent, {
      data: {
        sectionLabel: data.sectionType,
        fields: data.fields,
        concept: data.concept,
        term: data.term,
        languages: data.languages
      } as FieldPickerData,
      width: '450px'
    }).afterClosed().subscribe(context => {
      if (context) {
        this.getDialog().open(FeedbackDialogComponent, {
          data: {context},
          width: '500px'
        });
      }
    });
  }
}
